module.exports = __webpack_public_path__ + "static/img/hoverlogo09.3d850ca1.png";